import { REQUEST_STATUS__NULL } from '../../../util/constants';

export const initialState = {
  cancelRequestStatus: REQUEST_STATUS__NULL,
  acceptRequestStatus: REQUEST_STATUS__NULL,
};
